'use client';

import { createContext, PropsWithChildren, useContext } from 'react';

export type TClientEnvContext = {
  CREATE_APPEAL_URL: string;
};

const ClientEnvContext = createContext<TClientEnvContext>({
  CREATE_APPEAL_URL: '',
});

export const ClientEnvProvider = ({
  envs,
  children,
}: PropsWithChildren<{ envs: TClientEnvContext }>) => (
  <ClientEnvContext.Provider value={envs}>{children}</ClientEnvContext.Provider>
);

ClientEnvContext.displayName = 'ClientEnvContext';

export const useClientEnvContext = () => {
  const context = useContext(ClientEnvContext);

  if (!context) {
    throw new Error(
      'useClientEnvContext must be used within a ClientEnvContext, use ClientEnvProvider',
    );
  }

  return context;
};
